/**
 * Parse the `?video=` deep-link query param used by the AutoClipper Chrome
 * extension ("Send to AutoClipper" on YouTube pages) to hand a video URL to
 * the projects page. Returns the video URL, or null when absent or not a
 * plain http(s) URL.
 */
export function parseVideoDeepLink(search: string): string | null {
  const params = new URLSearchParams(search);
  const video = params.get('video');
  if (!video) return null;
  try {
    const url = new URL(video);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  } catch {
    return null;
  }
  return video;
}
